module.exports = __webpack_public_path__ + "img/bjfy_img.62630f99.png";